<template>
  <div class="flex flex-col justify-center mt-4 text-center">
    <TitreDeux :content="stats.value.utilisateur.email" fontSemiBold />
    <SimpleText :content="stats.value.utilisateur.livraison" color="text-gray-400" />
    <SimpleText :content="t(stats.value.utilisateur.role)" color="text-gray-400" />
  </div>

  <StatistiqueUtilisateur :stats="stats" />
</template>

<script setup>

import {defineProps, reactive} from "vue";
import {UtilisateurStores} from "@/stores/UtilisateurStores";
import {t} from "@/utils/Traduction";
import {enumeration} from "../../Enumeration";
import {router} from "@/routeur";
import {NotificationStores} from "@/stores/NotificationStores";
import TitreDeux from "@/components/atoms/TitreDeux.vue";
import SimpleText from "@/components/atoms/SimpleText.vue";
import StatistiqueUtilisateur from "@/components/organismes/StatistiqueUtilisateur.vue";

const utilisateurStore = UtilisateurStores();
const notificationStore = NotificationStores();

if(utilisateurStore.role !== enumeration.role.ADMIN) {
  utilisateurStore.logout(false);
  notificationStore.addNotification(t("youNeedToBeAdminToAccessThisPage"), 'error');
  router.push({ path: "/"});
}

const props = defineProps({
  uuid: {
    type: String,
    required: true,
  },
});


let stats = reactive({value: {
    utilisateur: {email: ''},
    nbPiecesTotal: 0,
    nbCommandes: 0,
    nbCommandesAnnuler: 0,
    avgPiecesParCommande: 0,
    nbPoidsTotal: 0,
    avgPoids: 0,
    nbTempsTotal: 0,
    avgTemps: 0,
    prixProductionTotal: 0,
    prixTotal: 0,
    couleurs: [],
    resteAPayer: 0,
    nbProduitParImprimante: [],
  }});

utilisateurStore.getStatsByUser(props.uuid).then((response) => {
  response.nbPoidsTotal = response.nbPoidsTotal / 1000;
  response.couleurs = response.couleurs.map((couleur) => {
    couleur.total = couleur.total / 1000;
    return couleur;
  });

  stats.value = response;
});

</script>

<style scoped>

</style>